export const LANGUAGE_SUCCESS = "LANGUAGE_SUCCESS"
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS"
export const GET_LANGUAGES_REQUEST = "GET_LANGUAGES_REQUEST"